export default "__VITE_ASSET__3cfe75d7__"